import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ManyEntity } from '@wilson/base';
import { ConfigOptions, ConfigService } from '@wilson/config';
import {
  OperationStatus,
  PublicationStatus,
  ShiftAssignmentMode,
  ShiftState,
} from '@wilson/interfaces';
import { Observable } from 'rxjs';
import {
  NumberRangeDto,
  SortOrder,
} from '../shift-work-times/shift-work-times.gateway';

export enum ShiftSelectionMode {
  OnlyIds = 'onlyIds',
  FullDetails = 'fullDetails',
  MinimalDetails = 'minimalDetails',
}

export interface GetShiftsSearchDto {
  from: string;
  to: string;
  id?: string[] | string;
  userIds?: string[];
  organizationalUnitIds?: string[];
  deviationRange?: NumberRangeDto;
  hasShiftNote?: boolean;
  hasReportComments?: boolean;
  agreementIds?: string[];
  allActivitiesHaveAgreement?: boolean;
  projectIds?: string[];
  labelIds?: string[];
  shiftState?: ShiftState[];
  operationalStatus?: OperationStatus[];
  publicationStatus?: PublicationStatus[];
  pageNumber?: number;
  pageSize?: number;
  orderBy?: ShiftsSortColumns;
  shiftSelectionMode?: ShiftSelectionMode;
  bypassPagination?: boolean;
  shiftAssignmentMode?: ShiftAssignmentMode;
  name?: string;
}

export interface ShiftsSortColumns {
  name: SortOrder | undefined;
  startDate: SortOrder | undefined;
  projectId: SortOrder | undefined;
  labels: { _count: SortOrder } | undefined;
  createdFrom: SortOrder | undefined;
  plannedDuration: SortOrder | undefined;
  reportedDuration: SortOrder | undefined;
  startDateTime: SortOrder | undefined;
  endDateTime: SortOrder | undefined;
  startLocation: { locationCode: SortOrder } | undefined;
  endLocation: { locationCode: SortOrder } | undefined;
  user: { lastName: SortOrder } | undefined;
  shiftCategory: { name: SortOrder } | undefined;
}

export interface ShiftWithMinimalDetails {
  id: string;
  name: string;
  state: ShiftState;
  operationalStatus: OperationStatus;
  publicationStatus: PublicationStatus;
  userId: string | null;
  projectId: string | null;
  agreementIds: string[];
  startDatetime: string;
  endDatetime: string;
  organizationalUnitId: string;
}

@Injectable({
  providedIn: 'root',
})
export class ShiftsV2Gateway {
  protected readonly http = inject(HttpClient);
  protected readonly config = inject<ConfigOptions>(ConfigService);

  public getShifts<T>(where: GetShiftsSearchDto): Observable<ManyEntity<T>> {
    let queryParams = new HttpParams();
    if (where.shiftSelectionMode) {
      queryParams = queryParams.set(
        'shiftSelectionMode',
        where.shiftSelectionMode,
      );
    }
    queryParams = queryParams.set(
      'bypassPagination',
      where.bypassPagination?.toString() ?? 'false',
    );

    return this.http.post<ManyEntity<T>>(
      `${this.config.host}/v2/shifts`,
      where,
      { params: queryParams },
    );
  }
}
